
export const Config ={
    //local
    //baseUrl: "https://192.168.100.52:8000/api",
    //redirectUri: "https://192.168.100.52:3000/login",
    
    //prod
    baseUrl: "https://manttrack-api.cetemin.net.pe/api",
    redirectUri: "https://manttrack.cetemin.net.pe/login",
  

    apiSsoma: "https://ssoma-api.cetemin.net.pe/api"
}

